import { CssBaseline, Typography, Grid, Avatar } from "@material-ui/core";
import { Helmet } from "react-helmet";
import { Theme, makeStyles, createStyles } from "@material-ui/core/styles";
import EmilieProfielFoto from "../images/fysiotherapie-nieuw-vennep-Emilie-Wegman-foto.png";
import JimmyProfielFoto from "../images/jimmy.jpg";
import Copyright from "./Copyright";
import NavigationBar from "../components/NavigationBar";
import TopBar from "../components/TopBar";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    icons: {
      color: "#4b0340",
      [theme.breakpoints.down("xs")]: {
        fontSize: 15,
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: 20,
      },
      [theme.breakpoints.up("md")]: {
        fontSize: 20,
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: 30,
      },
    },
    font: {
      padding: 0,
      color: "#3d072d",
      fontWeight: 600,
      [theme.breakpoints.down("xs")]: {
        fontSize: 14,
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: 14,
      },
      [theme.breakpoints.up("md")]: {
        fontSize: 16,
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: 18,
      },
    },
    avatar: {
      [theme.breakpoints.down("sm")]: {
        width: "20rem",
        height: "25rem",
      },
      [theme.breakpoints.up("md")]: {
        width: "25rem",
        height: "30rem",
        marginLeft: "2rem",
      },
      [theme.breakpoints.up("lg")]: {
        width: "30rem",
        height: "30rem",
      },
    },
    boodschap: {
      fontWeight: 400,
      marginTop: "0.5rem",
      [theme.breakpoints.down("xs")]: {
        fontSize: 14,
        marginLeft: "2rem",
        marginRight: "2rem",
        textAlign: "left",
        order: 1,
      },
      [theme.breakpoints.up("sm")]: {
        fontSize: 14,
        marginLeft: "4rem",
        textAlign: "left",
        order: 2,
      },
      [theme.breakpoints.up("md")]: {
        fontSize: 16,
        marginLeft: "6rem",
        textAlign: "left",
        order: 2,
      },
      [theme.breakpoints.up("lg")]: {
        fontSize: 18,
        marginLeft: "6rem",
        textAlign: "left",
        order: 2,
      },
    },
    imageGrid: {
      [theme.breakpoints.down("xs")]: {
        alignItems: "center",
        marginBottom: "1rem",
        order: 1,
      },
      [theme.breakpoints.up("sm")]: {
        alignItems: "center",
        marginBottom: "2rem",
        order: 1,
      },
      [theme.breakpoints.up("md")]: {
        alignItems: "center",
        marginBottom: "2rem",
        order: 2,
      },
      [theme.breakpoints.up("lg")]: {
        alignItems: "flex-start",
        marginBottom: "2rem",
        order: 2,
      },
    },
    infoGrid: {
      [theme.breakpoints.down("xs")]: {
        marginBottom: "2rem",
        order: 2,
      },
      [theme.breakpoints.up("sm")]: {
        marginTop: "2rem",
        marginBottom: "2rem",
        order: 1,
      },
      [theme.breakpoints.up("md")]: {
        marginTop: "2rem",
        marginBottom: "2rem",
        order: 1,
      },
      [theme.breakpoints.up("lg")]: {
        marginTop: "2rem",
        marginBottom: "2rem",
        order: 1,
      },
    },
  })
);

function OverDeTherapeut() {
  const classes = useStyles();
  return (
    <div style={{ background: "white !important" }}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>BOOST Fysiotherapie / Manuele therapie / Dry needling</title>
        <meta
          name="description"
          content="BOOST fysiotherapie is een specialistische praktijk voor fysio en manuele therapie in Nieuw Vennep. De praktijkeigenaar is Emilie Wegman, Manueel therapeut - OMT Orthopedische Manuele Therapie"
        />
        <meta
          property="og:title"
          content="BOOST Fysiotherapie / Manuele therapie / Dry needling"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="/over" />
      </Helmet>

      <CssBaseline />

      <TopBar />
      <NavigationBar />

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ marginTop: "1rem" }}
        direction="row"
      >
        <Grid
          container
          item
          direction="column"
          xs={12}
          sm={6}
          md={7}
          lg={7}
          alignItems="flex-start"
          className={classes.infoGrid}
        >
          <Typography
            component="h1"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            <strong style={{ color: "#3d072d" }}>Emilie Wegman</strong>
          </Typography>
          <Typography
            component="h1"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            Ik werk sinds 2009 als fysiotherapeut. In 2013 heb ik mij
            gespecialiseerd als manueel therapeut en in 2024 als orofaciaal
            fysiotherapeut.
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            Na ruim 12 jaar werkervaring bij verschillende praktijken ben ik
            sinds mei 2021 praktijkhouder van deze kleinschalige praktijk in het
            Ontmoetingscentrum in Nieuw-Vennep.
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            Hier behandel ik uiteenlopende pijn- en bewegingsklachten. Daarbij
            kijk ik naar het lichaam als geheel en heb ik aandacht voor hoe u
            beweegt in het dagelijks leven.
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            U kunt bij mij in het bijzonder terecht voor kaakklachten,
            nekklachten, hoofdpijn, rugklachten en schouderklachten
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            <strong>Werkdagen;</strong> maandag, dinsdag, donderdag en zaterdag
          </Typography>
        </Grid>
        <Grid
          container
          item
          direction="column"
          xs={12}
          sm={6}
          md={5}
          lg={5}
          className={classes.imageGrid}
        >
          <Avatar
            alt="Emilie Wegman"
            src={EmilieProfielFoto}
            className={classes.avatar}
          />
        </Grid>
      </Grid>

      <Grid
        container
        justifyContent="center"
        alignItems="center"
        style={{ marginTop: "1rem" }}
        direction="row"
      >
        <Grid
          container
          item
          direction="column"
          xs={12}
          sm={6}
          md={7}
          lg={7}
          alignItems="flex-start"
          className={classes.infoGrid}
        >
          <Typography
            component="h1"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            <strong style={{ color: "#3d072d" }}>Jimmy Nirmalsingh</strong>
          </Typography>
          <Typography
            component="h1"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            Ik ben fysiotherapeut sinds 2015 en heb in 2020 de Master of Science
            in Revalidatiewetenschappen en Fysiotherapie behaald. Daarnaast heb
            ik een achtergrond in geneeskunde en een opleiding in orthopedische
            technologie, met specifieke expertise in orthesen en prothesen.
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            Met deze brede achtergrond begeleid ik patiënten bij het herstellen
            van klachten aan het bewegingsapparaat, met focus op het verbeteren
            van mobiliteit, kracht en dagelijks functioneren.
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            Mijn werkwijze is praktisch en actief. Ik behandel hands-on waar
            nodig en combineer dit met gerichte oefentherapie. Dit sluit goed
            aan bij mijn ervaring en persoonlijke aanpak.
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            Mijn behandelingen zijn gericht op persoonlijk herstel en
            functioneel bewegen, zodat u weer veilig en zelfstandig kunt
            deelnemen aan het dagelijks leven, werk en sport.
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            Ik behandel uiteenlopende klachten, met een focus op
            sportgerelateerde en postoperatieve revalidatie. U kunt hierbij
            denken aan knie- en enkelklachten, heup- en bilklachten,
            rugklachten, schouderklachten en revalidatie na operaties zoals een
            heup- of knieprothese (THP/TKP).
          </Typography>
          <Typography
            component="span"
            color="textPrimary"
            align="left"
            className={classes.boodschap}
          >
            <strong>Werkdagen;</strong> vrijdag
          </Typography>
        </Grid>
        <Grid
          container
          item
          direction="column"
          xs={12}
          sm={6}
          md={5}
          lg={5}
          className={classes.imageGrid}
        >
          <Avatar
            alt="Jimmy Nirmalsingh"
            src={JimmyProfielFoto}
            className={classes.avatar}
          />
        </Grid>
      </Grid>

      <Grid
        container
        justifyContent="center"
        style={{
          background: "black",
          position: "fixed",
          bottom: "0",
          width: "100%",
        }}
      >
        <Copyright />
      </Grid>
    </div>
  );
}

export default OverDeTherapeut;
